export const GET_UNSUBS_DATA = 'unsubs/GET_UNSUBS_DATA';
export const GET_UNSUBS_DATA_SUCCESS = 'unsubs/GET_UNSUBS_DATA_SUCCESS';
export const GET_UNSUBS_DATA_FAIL = 'unsubs/GET_UNSUBS_DATA_FAIL';
export const GET_UNSUBS_DATA_TOTAL = 'unsubs/GET_UNSUBS_DATA_TOTAL';
export const GET_UNSUBS_DATA_TOTAL_SUCCESS = 'unsubs/GET_UNSUBS_DATA_TOTAL_SUCCESS';
export const GET_UNSUBS_DATA_TOTAL_FAIL = 'unsubs/GET_UNSUBS_DATA_TOTAL_FAIL';
export const GET_UNSUBS_DRILL_DATA = 'unsubs/GET_UNSUBS_DRILL_DATA';
export const GET_UNSUBS_DRILL_DATA_SUCCESS = 'unsubs/GET_UNSUBS_DRILL_DATA_SUCCESS';
export const GET_UNSUBS_DRILL_DATA_FAIL = 'unsubs/GET_UNSUBS_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/unsubs.js